<template>
  <v-list-item-title>
    <slot />
  </v-list-item-title>
</template>

<script>
export default {
  props: {},
};
</script>
